import { render, staticRenderFns } from "./serviceIntroduction.vue?vue&type=template&id=01c47e62&scoped=true"
import script from "./serviceIntroduction.vue?vue&type=script&lang=js"
export * from "./serviceIntroduction.vue?vue&type=script&lang=js"
import style0 from "./serviceIntroduction.vue?vue&type=style&index=0&id=01c47e62&prod&lang=scss&scoped=true"
import style1 from "./serviceIntroduction.vue?vue&type=style&index=1&id=01c47e62&prod&lang=scss"
import style2 from "./serviceIntroduction.vue?vue&type=style&index=2&id=01c47e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c47e62",
  null
  
)

export default component.exports